export const DELIVERY_BOX_SIZE_MODAL_NAME = 'delivery-box-size-edit-modal'
export const DELIVERY_ADDRESS_MODAL_NAME = 'delivery-address-edit-modal'
